const quiz = {
  namespaced:true,
  state: {
    currentIndex: 1,
    selectedAnswer: [],
  },
  mutations: {
    SET_SELECTED_ANSWER(state: any, payload: any) {
      state.selectedAnswer = payload;
    },
    SET_CURRENT_INDEX(state: any, payload: any) {
      state.currentIndex = payload;
    }
  },
}

export default quiz;
